import { getNewMilestonesFromGrant } from './exploreUnknownNewMilestonesFromGrant';

export const EU_LEVEL100_DOOR_UNLOCKED_TOAST_KEY = 'euLevel100DoorUnlockedToastSeen';

/**
 * @returns {void}
 */
export function markExploreUnknownLevel100DoorUnlockSeen() {
  try {
    localStorage.setItem(EU_LEVEL100_DOOR_UNLOCKED_TOAST_KEY, '1');
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * True when this XP grant newly unlocks the Explore End door (reach level 100).
 * @param {object|null|undefined} grant
 * @returns {boolean}
 */
export function grantUnlocksExploreUnknownLevel100Door(grant) {
  if (!grant) {
    return false;
  }
  const levelBefore = Number(grant.levelBefore) || 1;
  const levelAfter = Number(grant.levelAfter) || levelBefore;
  if (levelAfter < 100) {
    return false;
  }
  if (levelBefore >= 100) {
    return false;
  }
  const milestones = getNewMilestonesFromGrant(grant);
  if (milestones.includes(100)) {
    return true;
  }
  return grant.leveledUp === true;
}
